import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { defaultPagamentoTituloLista, PagamentoTituloLista } from 'src/app/interface/titulo';
import { Zpr } from 'src/app/interface/zpr';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { FiltroListaTitulo } from '../../filter/filtro-lista-titulo';
import { getPedidoDefault, PedidoDto } from '../../interface/pedido';
import { PedidoService } from '../../service/pedido.service';
import { FiltroPedidoLista } from '../filtro/filtro-lista-faturamento-guarita';
import { FinReceberService } from 'src/app/financeiro/service/fin-receber.service';

@Component({
  selector: 'app-pedido-venda-lista',
  templateUrl: './pedido-venda-lista.component.html',
  styleUrls: ['./pedido-venda-lista.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PedidoVendaListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroPedidoLista;
  filtroTitulos: FiltroListaTitulo;

  valorTotalTitulos: number;

  listaTitulosCliente: PagamentoTituloLista;

  pedidoSelecionado: PedidoDto = getPedidoDefault();

  guarita: string = '';
  guaritaNome: string = '';

  guaritaAdvancedFilters: Array<PoDynamicFormField>;
  guaritaColumnsFilters: Array<PoLookupColumn>;
  guaritaFieldFormaterFilters: (value: Zpr) => string;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private pedidoService: PedidoService,
    private finReceberService: FinReceberService,
    public zprLookupService: ZprLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroPedidoLista(this.poStorageService);
    this.filtroTitulos = new FiltroListaTitulo();

    this.valorTotalTitulos = 0;

    this.zprLookupService.grupo      = 'GUARITA';
    this.guaritaAdvancedFilters      = this.zprLookupService.getAdvancedFilter();
    this.guaritaColumnsFilters       = this.zprLookupService.getColumnsFilter();
    this.guaritaFieldFormaterFilters = this.zprLookupService.getFieldFormater;

    this.listaTitulosCliente = defaultPagamentoTituloLista();
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('listaTitulosModal', { static: true }) listaTitulosModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.tabelaPrincipalFiltro.dados.CC5ORIGSOL = 'POSTPEDIDO';

    this.guarita = this.tabelaPrincipalFiltro.dados.CC5GUARITA;

    this.pedidoService.listaPedidos(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        let fav = ['visualizar', 'deletar', 'residuo', 'titulos'];
        if (!item.CC5LIBEROK && !item.CC5NOTA && !item.CC5BLQ) {
          item.status = 'EM_ABERTO';
          fav = ['edit', 'deletar', 'residuo', 'titulos'];
        } else if (item.CC5NOTA || (item.CC5LIBEROK == 'E' && !item.CC5BLQ)) {
          item.status = 'ENCERRADO';
        } else if (item.CC5LIBEROK && !item.CC5NOTA && !item.CC5BLQ) {
          item.status = 'LIBERADO';
        } else if (item.CC5BLQ == "1" && !item.CC5LIBEROK && !item.CC5NOTA) {
          item.status = 'BLOQUEADO';
          fav = ['edit', 'deletar', 'residuo', 'titulos'];
        } else if (item.CC5BLQ == "2" && !item.CC5LIBEROK && !item.CC5NOTA) {
          item.status = 'BLOQUEADOPORVALOR';
          fav = ['edit', 'deletar', 'residuo', 'titulos'];
        }
        return { ...item, favorite: fav };
      });
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {
      property: 'status',
      type: 'label',
      width: '10%',
      labels: [
        { value: 'EM_ABERTO', color: 'color-11', label: 'Em Aberto' },
        { value: 'ENCERRADO', color: 'color-07', label: 'Encerrado' },
        { value: 'LIBERADO' , color: 'color-01', label: 'Liberado'  },
        { value: 'BLOQUEADO', color: 'color-08', label: 'Bloqueado' },
        { value: 'BLOQUEADOPORVALOR', color: 'color-08', label: 'Bloqueado por Valor' },
      ]
    },
    {property: 'CC5NUM'       , label: 'Pedido'       },
    {
      property: 'CC5TIPO',
      label: 'Tipo',
      type: 'label',
      width: '10%',
      labels: [
        { value: 'N', color: 'color-11', label: 'Normal' },
        { value: 'B', color: 'color-07', label: 'Utiliza Fornecedor' },
      ]
    },
    {property: 'CZACPROJET'   , label: 'Projetos'      },
    {property: 'CZACINTERVDESC', label: 'Intervenção'      },
    {property: 'NQTDPENDENTE' , label: 'Saldo'   , type: 'number', format: '1.5-5'      },
    {property: 'CC5CLIENTE'   , label: 'Cod Cliente'  },
    {property: 'CC5LOJACLI'   , label: 'Loja'         },
    {property: 'CA1NREDUZ'    , label: 'Cliente'      },
    {property: 'CC5GUARITA'   , label: 'Cód. Guarita' },
    {property: 'CGUARITADESC' , label: 'Guarita'      },
    {property: 'DC5EMISSAO'   , label: 'Emissão' , type: 'date'  , format: 'dd/MM/yyyy' },
    {property: 'favorite'     , label: '...'     , width: '13%', type: 'icon',
      icons: [
        {
          action: this.edit.bind(this),
          icon: 'po-icon-edit',
          tooltip: 'Editar',
          value: 'edit',
        },
        {
          action: this.edit.bind(this),
          icon: 'po-icon-eye',
          tooltip: 'Visualizar',
          value: 'visualizar',
        },
        {
          action: this.deletar.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Deletar',
          value: 'deletar',
          disabled: this.disableDeletar.bind(this)
        },
        {
          action: this.eliminarResiduo.bind(this),
          icon: 'po-icon-exit',
          tooltip: 'Eliminar Resíduo',
          value: 'residuo',
          disabled: this.disableDeletar.bind(this)
        },
        {
          action: this.listaTitulos.bind(this),
          icon: 'po-icon-finance',
          tooltip: 'Títulos',
          value: 'titulos',
          disabled: this.disableListaTitulos.bind(this)
        },
      ]
    }
  ];

  public readonly colunasTitulos: Array<PoTableColumn> = [
    {property: 'CE1FILIAL' , label: 'Filial'         },
    {property: 'CE1NUM'    , label: 'Número'         },
    {property: 'CE1TIPO'   , label: 'Tipo'           },
    {property: 'DE1EMISSAO', label: 'Emissão'        , type: 'date'    , format: 'dd/MM/yyyy'},
    {property: 'DE1VENCTO' , label: 'Vencimento'     , type: 'date'    , format: 'dd/MM/yyyy'},
    {property: 'DE1VENCREA', label: 'Vencto Real'    , type: 'date'    , format: 'dd/MM/yyyy'},
    {property: 'NE1VALOR'  , label: 'Valor'          , type: 'currency', format: 'BRL'},
    {property: 'NE1SALDO'  , label: 'Saldo'          , type: 'currency', format: 'BRL'},
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Pedido de Venda', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  edit(row: PedidoDto): void {
    this.router.navigateByUrl(`/faturamento/pedido-venda/cadastro/alterar/${row.CC5NUM}`);
  }

  disableDeletar(row: PedidoDto): boolean {
    return row.status == 'ENCERRADO' || row.status == 'LIBERADO';
  }

  disableListaTitulos(row: PedidoDto): boolean {
    return row.CC5TIPO == 'B';
  }

  deletar(row: PedidoDto): void {
    this.poDialogService.confirm({
      title: 'Deletar Pedido de Venda',
      message: 'Deseja realmente deletar o Pedido de Venda?',
      confirm: () => this.confirmaDeletarPedido(row)
    });
  }

  confirmaDeletarPedido(pedido: PedidoDto): void {
    this.pedidoService.deletarPedido(pedido.CC5NUM).subscribe((ret) => {
      this.poNotificationService.success("Pedido excluído com sucesso!");
      this.tabelaPrincipalLoad();
    });
  }

  eliminarResiduo(row: PedidoDto): void {
    this.poDialogService.confirm({
      title: 'Eliminar Resíduo do Pedido de Venda',
      message: 'Deseja realmente eliminar o resíduo do Pedido de Venda?',
      confirm: () => this.confirmaEliminarResiduoPedido(row)
    });
  }

  confirmaEliminarResiduoPedido(pedido: PedidoDto): void {
    this.pedidoService.eliminarResiduoPedido(pedido.CC5NUM).subscribe((ret) => {
      this.poNotificationService.success("Resíduo eliminado com sucesso!");
      this.tabelaPrincipalLoad();
    });
  }

  listaTitulos(row: PedidoDto): void {
    this.filtroTitulos.setDefault();
    this.filtroTitulos.dados.CE1FILIAL = 'ALL';
    this.filtroTitulos.dados.CE1CLIENTE = row.CC5CLIENTE;
    this.filtroTitulos.dados.CE1LOJA = row.CC5LOJACLI;
    this.filtroTitulos.dados.order = 'E1_VENCTO';
    this.valorTotalTitulos = 0;
    this.finReceberService.listaTitulos(this.filtroTitulos.dados).subscribe((ret) => {
      ret.items.map((item) => {
        this.valorTotalTitulos += item.NE1SALDO;
      });
      this.listaTitulosCliente = ret;
      this.listaTitulosModal.open();
    })
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
